import React from "react";
import ContactForm from "../Components/contactus/ContactForm";
import ContactDetails from "../Components/contactus/ContactDetails";

const Contact = () => {
  return (
    <div style={{ background: 'var(--bg-primary)' }}>
      {/* ── HERO SECTION ── */}
      <section className="relative min-h-[50vh] flex flex-col justify-center px-6 pt-28 pb-16 max-w-7xl mx-auto overflow-hidden">
        {/* Background orbs */}
        <div className="absolute -top-40 -left-32 w-[600px] h-[600px] rounded-full pointer-events-none"
             style={{ background: 'radial-gradient(circle, rgba(37,99,235,0.06), transparent 70%)', filter: 'blur(80px)' }} />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none"
             style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.05), transparent 70%)', filter: 'blur(80px)' }} />

        <div className="relative z-10 max-w-5xl">
          {/* Availability Badge */}
          <div className="flex items-center gap-2 px-3.5 py-1.5 rounded-full border text-[10px] font-bold w-fit mb-6"
               style={{ borderColor: 'var(--border-color)', color: 'var(--text-secondary)', background: 'var(--bg-card)' }}>
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
            Available for new projects
          </div>

          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-8 bg-slate-400/40" />
            <span className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400">Get in touch</span>
          </div>

          {/* Headline */}
          <h1
            className="font-black leading-[1.05] tracking-tight mb-6"
            style={{ fontSize: 'clamp(2.4rem, 6vw, 4.5rem)', color: 'var(--text-primary)' }}
          >
            Let's build<br />
            <span className="gradient-text-purple">something serious.</span>
          </h1>

          {/* Sub headline */}
          <p className="text-base leading-relaxed max-w-2xl text-slate-500 dark:text-zinc-400">
            Have a project in mind? We'd love to hear about it. Drop us a line and we'll scope a clear 
            roadmap for your digital product.
          </p>
        </div>
      </section>

      {/* ── CONTENT AREA ── */}
      <section className="relative z-10 border-t py-16 md:py-24" style={{ background: 'var(--bg-surface)', borderColor: 'var(--border-color)' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Contact Details */}
            <div className="lg:w-[38%]">
              <ContactDetails />
            </div>

            {/* Contact Form */}
            <div className="lg:w-[62%]">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;